import { GuidelineState } from './GuidelineState';
import { UserDto } from './UserDto';

export enum GuidelineReviewStatus {
  None,
  Approved,
  RequestChanges,
}

export type GuidelineReviewActivity = {
  id: string;
  status: GuidelineReviewStatus;
  updatedAt: Date;
};

export type GuidelineReview = {
  id: string;
  guidelineUniqueId: string;
  guidelineVersion: number;
  reviewer: UserDto;
  status: GuidelineReviewStatus;
  updatedAt: Date;
  isActive: boolean;
  assignedBy: UserDto;
  assignedAt: Date;
  unAssignedBy?: UserDto;
  unAssignedAt?: Date;
  guidelineReviewActivities: GuidelineReviewActivity[];
};

export type GuidelineReviewInfo = {
  uniqueId: string;
  owner: UserDto;
  createdAt: string;
  title: string;
  reviewedAt?: string;
  reviewStatus: GuidelineReviewStatus;
  guidelineStatus: GuidelineState;
  reviewers: UserDto[];
  reviews: GuidelineReview[];
  version: string;
  authors: UserDto[];
  IsGuidelineUpdated?: boolean;
};
